import { Component, HostListener, OnInit } from '@angular/core';
import { ClientsService } from './clients/clients.service';
import { IconService } from './material/icon.service';
import { WatchdogService } from './watchdog/watchdog.service';
import { UserActivityService } from './user-activity/user-activity.service';
import { LicenseService } from './license/license.service';
import { Observable } from 'rxjs';
import { LicenseState } from './license/store/license.reducers';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
    correlationId: string;
    licenseState$: Observable<LicenseState | undefined>;

    constructor(
        private readonly iconService: IconService,
        private readonly clientsService: ClientsService,
        private readonly watchdogService: WatchdogService,
        private readonly userActivityService: UserActivityService,
        private readonly licenseService: LicenseService
    ) {
        this.correlationId = this.clientsService.getCorrelationId();
        this.iconService.registerIcons();
        this.watchdogService.start();
        this.userActivityService.setTimeout();
        this.userActivityService.userInactive.subscribe(() => window.location.reload());
        this.licenseState$ = licenseService.getLicenseState();
    }

    ngOnInit(): void {
        this.licenseService.activateDevice();
    }

    @HostListener('window:mousedown') refreshUserState() {
        clearTimeout(this.userActivityService.userActivity);
        this.userActivityService.setTimeout();
    }
}
